import { HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";

@Injectable({
	providedIn: 'root',
})
export class HttpHelper {
	public SetRequiredAwsHttpPostHeaders() {
		return {
			headers: new HttpHeaders({
				'Content-Type': 'application/json',
				'Authorization': 'none',
				'X-Amz-Date': new Date().toISOString(),
			})
		};
	}
}
